import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BackButtonConfirmationModalComponent } from './back-button-confirmation-modal.component';



@NgModule({
  declarations: [
    BackButtonConfirmationModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    BackButtonConfirmationModalComponent,
  ]
})
export class BackButtonConfirmationModalModule { }
